/* eslint-disable no-param-reassign */

const panels = [{
  title: '属性',
  labelWidth: '100px',
  items: [{
    text: '组件名称',
    name: 'name',
  }, {
    name: 'actItem',
    type: 'select',
    remote: true,
    valueKey: 'componentType',
    option: {
      url: '/v4/node/api?_c=ui_component&_a=getButtonActionList',
      root: 'data',
      text: 'c_name',
      value: item => ({
        componentType: item.c_component_type,
        modType: item.c_mod_type,
        name: item.c_name,
      }),
    },
    text: '功能',
    onChange: (vm, { componentType = '', modType }, { model }) => {
      model.act = componentType;
      if (!modType) {
        model.modId = '';
      }
      const initValue = vm.componentValue.getValue(`${componentType}Button`);
      const eid = initValue?.dtEid || 'button';
      model.dtEid = eid;
      if (model?.report?.click) {
        model.report.click.eid = eid;
      }
      if (model?.report?.expose) {
        model.report.expose.eid = eid;
      }
    },
  }, {
    name: 'act',
    type: 'hidden',
  }, {
    type: 'pop-select',
    text: '关联弹窗',
    name: 'pop',
    display: (vm, { model }) => model.act && model.act.toLowerCase().endsWith('pop'),
  }, {
    type: 'panel',
    labelWidth: '100px',
    key: 'act',
    title: (vm, { formValue }) => formValue.actItem?.name,
    itemsFunction: (vm, value) => {
      if (!value || value.toLowerCase().endsWith('pop')) {
        return [];
      }

      const act = value.replace(/-(\w)/g, (all, letter) => letter.toUpperCase());

      const config = vm.componentConfig.getConfig(`${act}Button`, vm.mForm.values, {
        enabledPlugins: vm.mForm?.editor?.editorCore.app.value.plugins || [],
        autoFillTab: false,
      });

      return config;
    },
  }, {
    type: 'component',
    id: 'buttonStatus',
  }, {
    type: 'panel',
    title: '位置大小',
    items: [{
      type: 'component',
      id: 'devConfig',
    }, {
      type: 'component',
      id: 'rect',
    }],
  }],
}];

export default [{
  type: 'tab',
  active: '0',
  items: panels,
}];
